import { FormikConsumer, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { isDebugMode } from "shared/debug";
import { Environment } from "shared/utils/enums";

export function FormDebug({ nestedView }: { nestedView?: boolean }) {
  if (isDebugMode || process.env.REACT_APP_CUSTOM_ENV === Environment.LOCAL) {
    return <FormDebugComponent nestedView={!!nestedView} />;
  }

  return null;
}

function FormDebugComponent({ nestedView }: { nestedView: boolean }) {
  const { values, setValues, submitCount } = useFormikContext();
  const [savedForm, setSavedForm] = useState(() => localStorage.getItem(window.location.href));
  useEffect(() => {
    if (submitCount) {
      localStorage.setItem(window.location.href, JSON.stringify(values));
      setSavedForm(JSON.stringify(values));
    }
  }, [submitCount, values]);
  return (
    <details className="form_debug">
      <summary className="form_debug_head">
        Formik State{" "}
        {!!savedForm && (
          <button
            onClick={e => {
              e.preventDefault();
              setValues(JSON.parse(savedForm));
            }}>
            Autofill
          </button>
        )}
      </summary>
      <FormikConsumer>
        {({ validationSchema, validate, ...rest }) => (
          <pre className="form_debug_body">
            {nestedView
              ? `Nested View not implemented ${JSON.stringify(rest, null, 2)}`
              : JSON.stringify(rest, null, 2)}
          </pre>
        )}
      </FormikConsumer>
    </details>
  );
}
